import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

export const GetCallsList = (url: string, type: string, params: any) => {
  return API.get(`/${C300}/${type}call_log/${url}/`, undefined, params);
};

export const ChangeTag = (
  url: string,
  id: string,
  params: { [key: string]: string }
) => {
  return API.gatewayPatch(
    `/${C300}/update/${url}/${id}/tag/`,
    undefined,
    params
  );
};

export const ChangeRating = (
  url: string,
  id: string,
  params: { [key: string]: string }
) => {
  return API.gatewayPatch(
    `/${C300}/update/${url}/${id}/rating/`,
    undefined,
    params
  );
};

export const ChangeCaller = (
  url: string,
  id: string,
  params: { [key: string]: string }
) => {
  return API.gatewayPatch(
    `/${C300}/update/${url}/${id}/caller/`,
    undefined,
    params
  );
};

export const AddNote = (
  url: string,
  id: string,
  params: { [key: string]: string }
) => {
  return API.gatewayPatch(
    `/${C300}/update/${url}/${id}/note/`,
    undefined,
    params
  );
};

export const AddComment = (
  url: string,
  id: string,
  params: { [key: string]: string }
) => {
  return API.gatewayPatch(
    `/${C300}/update/${url}/${id}/comment/`,
    undefined,
    params
  );
};

/* Получение информации о звонящем */
export const GetCallerData = (id: string, params: IParams) =>
  API.get(`/${C300}/call_entity/`, id, params);

/* Инициирование транскрибации */
export const InitTranscribation = (callId: string) =>
  API.gatewayPost(`/${C300}/ml_transcript/`, { call_id: callId });

/* Получение информации о беззвучном режиме */
export const GetDndMode = () => API.get(`/${C300}/form/dnd_mode/`);

/* Изменение dnd-mode отвечающего за беззвучный режим */
export const PostDndMode = (data: IParams) =>
  API.gatewayPost(`/${C300}/form/telephony/dnd_mode/`, data);

/* Сбросить звонок из интерфейса */
export const PostHungUpCall = (callId: string) =>
  API.gatewayPost(`/${C300}/action/hung_up/`, { id: callId });

/* Получить начальную информацию по телефонии (аналог подключению к старому сокету calls/ws */
export const GetTelephonyInitialData = () =>
  API.get(`/${C300}/telephony/status/current/`);

/* Совершить колбек (позвонить по клику на трубку) - замена старому событию сокета telephony_make_callback */
export const MakeCallback = (dst: string) =>
  API.gatewayPost(`/${C300}/telephony/action/callback/`, {
    dst,
  });

/* Совершить перезвон (позвонить по клику на трубку) - замена старого события сокета telephony_make_redial */
export const MakeRedial = (uniqueid: string) =>
  API.gatewayPost(`/${C300}/telephony/action/redial/`, {
    call_id: uniqueid,
  });

/* Обновление звонка */
export const UpdateCall = (params: { callid: string } & IParams) => {
  return API.gatewayPatch(
    `/${C300}/telephony/action/update/`,
    undefined,
    params
  );
};

/* Перевод звонка на робота для сдачи показаний счётчиков */
export const GoToRobot = (callId: string) =>
  API.gatewayPost(`/${C300}/form/processing_call/transfer_to_robot/`, {
    call_id: callId,
  });
